import { FaSignInAlt, FaSignOutAlt, FaUser } from 'react-icons/fa'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { logout, reset } from '../features/auth/authSlice'

function Header() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)

  const onLogout = () => {
    dispatch(logout())
    dispatch(reset())
    navigate('/')
  }

  return (
    <header className='header'>
      <div className='logo'>
        <Link to='/'>PieGalda Jumis API</Link>
      </div>
      <ul>
        {user ? (
          <li className='flex gap-10'>
            <button className='btn' onClick={() => navigate('/free-shipping')}>
              Bezmaksas piegāde
            </button>
            <button className='btn' onClick={() => navigate('/coupons')}>
              Kuponi
            </button>
            <button className='btn' onClick={() => navigate('/meistarklases')}>
              Meistarklases
            </button>
            <button className='btn' onClick={onLogout}>
              <FaSignOutAlt /> Iziet
            </button>
            
          </li>
        ) : (
          <>
            <li>
              <Link to='/login'>
                <FaSignInAlt /> Pieslēgties
              </Link>
            </li>
          </>
        )}
      </ul>
    </header>
  )
}

export default Header